import { render, staticRenderFns } from "./CurrencyDialog.vue?vue&type=template&id=7a5e8fc4&scoped=true"
import script from "./CurrencyDialog.vue?vue&type=script&lang=js"
export * from "./CurrencyDialog.vue?vue&type=script&lang=js"
import style0 from "./CurrencyDialog.vue?vue&type=style&index=0&id=7a5e8fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5e8fc4",
  null
  
)

export default component.exports